import Container from '@mui/material/Container'
import { Outlet } from 'react-router'

export default function ContainerLayout() {
  return (
    <Container maxWidth='xl' disableGutters>
      <Outlet />
    </Container>
  )
}
